<template>
    <div id="shadow-wrapper" class="rounded bg-white p-3">
        <template v-if="channel != null">
            <div id="notifications-header" >
                <div class="d-inline-block">
                    <h2>{{ channel.channel_name }}</h2>
                </div>
                <div class="d-inline-block px-3 modal-form">
                    <switches
                        v-model="channel.is_enabled"
                        theme="custom"
                        color="primary"
                        text-enabled="On"
                        text-disabled="Off"
                        type-bold="true"
                        :emit-on-mount="false"
                        :disabled="loading"
                        style="top: -23px; height: 20px;"
                        @input="toggleChannel(channel)"
                    ></switches>
                </div>
            </div>
            <b-card class="notifications-container" no-body :key="channel.channel_name">
                <!-- Start Modal for Toggling Channel -->
                <b-modal 
                    :ref="'toggleChannelModal' + channel.channel_uuid"
                    hide-header
                    hide-footer
                    centered
                    no-close-on-esc
                    no-close-on-backdrop
                >
                    <div class="switch-tab-modal-message text-center">
                        <img
                            src="@/assets/images/notifications/warning-yellow.svg"
                            class="d-inline-block"
                        />
                        <p class="d-inline-block px-3 text-justify">Turning this off will make this channel inactive. <br> Would you like to proceed?</p>
                    </div>
                    <div class="text-right">
                        <b-button variant="tertiary" style="width: 100px; height: 35px;" :disabled="loading" class="cancel-btn mx-2" @click="cancelToggleChannel(channel)">No</b-button>
                        <b-button variant="primary" style="width: 100px; height: 35px;" :disabled="loading" class="save-changes-btn mx-2" @click="saveToggleChannel(channel)">Yes</b-button>
                    </div>
                </b-modal>
                <b-modal 
                    :ref="'switchTabModal'"
                    hide-header
                    hide-footer
                    centered
                    no-close-on-esc
                    no-close-on-backdrop
                >
                    <div class="switch-tab-modal-message text-center">
                        <img
                            src="@/assets/images/notifications/warning-yellow.svg"
                            class="d-inline-block"
                        />
                        <p class="d-inline-block px-3 text-justify">Save changes before changing to standard. <br> If you don't save your changes it will be lost.</p>
                    </div>
                    <div class="text-center">
                        <b-button variant="tertiary" :disabled="loading" class="do-not-save-btn mx-2" @click="doNotSave(switchTabForm.templateIndex, switchTabForm.template)">Don't Save</b-button>
                        <b-button variant="tertiary" :disabled="loading" class="cancel-btn mx-2" @click="cancelSave(switchTabForm.templateIndex, switchTabForm.template)">Cancel</b-button>
                        <b-button variant="primary" :disabled="loading" class="save-changes-btn mx-2" @click="preValidateForm(switchTabForm.templateIndex, switchTabForm.template, channel, 'modal')">Save Changes</b-button>
                    </div>
                </b-modal>
                <!-- End Modal for Toggling Channel -->
                <b-tabs pills card>
                    <!-- Tab Contents Start -->
                    <b-tab :title="category.name" v-for="(category, categoryIndex) in categories" :key="categoryIndex" @click="getNotificationTemplates(category)">
                        <div role="tablist">
                            <!-- Notification Start -->
                            <b-card
                                no-body
                                class="specific-notification mb-4"
                                v-for="(template, templateIndex) in templates.types" :key="templateIndex"
                            >

                                <b-card-header header-tag="header" class="p-0" role="tab">
                                    <div>
                                        <b-row no-gutters>
                                            <b-col class="p-4">
                                                <h2>
                                                    {{ template.name == 'One Time Pin' ? 'One Time PIN' : template.name }}
                                                </h2>
                                            </b-col>
                                            <b-col cols="2">
                                                <div class="float-right pr-4">
                                                    <div class="modal-form" v-bind:class="{ 'd-inline-block': template.name != 'One Time Pin', 'd-none': template.name == 'One Time Pin' }">
                                                        <switches
                                                            v-model="template.customize.is_enabled"
                                                            theme="custom"
                                                            color="primary"
                                                            :disabled="loading"
                                                            type-bold="true"
                                                            :emit-on-mount="false"
                                                            style="top: 30px; height: 20px;"
                                                            @input="toggleNotificationType(template)"
                                                        ></switches>
                                                    </div>
                                                    <div class="text-center action-button d-inline-block" style="width: 30px;">
                                                        <div :key="template.uuid" v-b-toggle="templateIndex.toString()">
                                                            <img
                                                                src="@/assets/images/icons/dropdown.svg"
                                                                alt="Collapse Icon"
                                                                class="d-inline-block when-closed ml-2 icon"
                                                            />
                                                            <img
                                                                src="@/assets/images/icons/dropdown.svg"
                                                                alt="Expand Icon"
                                                                class="d-inline-block when-opened ml-2 icon expand"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </b-col>
                                        </b-row>
                                    </div>
                                </b-card-header>
                                <b-collapse
                                    :id="templateIndex.toString()"
                                    visible
                                    accordion="my-accordion"
                                    role="tabpanel"
                                    :key="template.uuid"
                                    @hide="resetForm(templateIndex, template)"
                                >
                                    
                                    <b-card-body>
                                        <b-card no-body class="notification-form">
                                            <div class="notification-button-container py-2 px-4">
                                                <b-button-group size="sm">
                                                    <b-button class="py-1 px-3" :disabled="loading" :variant="template.customize.is_standard ? 'primary' : 'tertiary'" @click="switchTab('standard', templateIndex, template)">Standard</b-button>
                                                    <b-button class="py-1 px-3" :disabled="loading" :variant="!template.customize.is_standard ? 'primary' : 'tertiary'" @click="switchTab('customize', templateIndex, template)">Customize</b-button>
                                                </b-button-group>
                                            </div>
                                            <div class="px-4 pb-4" style="min-height: 330px;">
                                                <template v-if="template.customize.is_standard">
                                                    <label for="">Message</label>
                                                    <div class="editable-div p-3" v-html="wrapVariables(template.standard.value, template.standard.allowed_variables)">
                                                    </div>

                                                    <div class="save-changes-and-character-count-container" v-bind:class="{ 'off-set-save-changes-and-character-count': isActive.button }">
                                                        <span class="character-count">
                                                            {{ getTextLength(template.customize.custom_value_for_editing, selectedChannel) }}
                                                        </span>
                                                        <b-button
                                                            style="margin-top: 35px;" 
                                                            class="save-changes-button" 
                                                            variant="primary" 
                                                            :disabled="loading" 
                                                            @click="saveNotificationTemplate(template)"
                                                        >
                                                            Apply Changes
                                                        </b-button>
                                                    </div>
                                                </template>
                                                <template v-else>
                                                    <label for="">Message</label>
                                                    <!-- Start New Editable Div -->
                                                    <div v-bind:class="{ 'd-none': isActive.button }" class="quill-container">
                                                        <vue-editor placeholder="Enter message" :editorToolbar="customToolbar" :editorOptions="editorSettings" v-model="template.customize.custom_value_for_editing"></vue-editor>
                                                    </div>
                                                    
                                                    <!-- End New Editable Div -->
                                                    <!-- Start Draggable Area -->
                                                    <template v-if="draggable_custom_value != undefined">
                                                        <draggable
                                                            :id="'draggable-div-' + template.customize.uuid"
                                                            class="draggable-div p-3"
                                                            v-bind:class="{ 'd-none': !isActive.button }"
                                                            :list="draggable_custom_value"
                                                            @change="log"
                                                            :group="{
                                                                name: 'words',
                                                                pull: true,
                                                                put: true
                                                            }"
                                                        >
                                                            <div 
                                                                class="d-inline-block p-2"
                                                                v-for="(element, index) in draggable_custom_value"
                                                                :key="element.id"
                                                            >
                                                                <template v-if="isVariable(element.word, template.standard.allowed_variables)">
                                                                    <span style='color: #5182ff;'>
                                                                        {{ element.word }}
                                                                        <img
                                                                            @click="removeVariable(index)"
                                                                            src="@/assets/images/actions/remove.svg"
                                                                            class="d-inline-block remove-icon"
                                                                        />
                                                                    </span>
                                                                </template>
                                                                <template v-else>
                                                                    {{ element.word }}
                                                                </template>
                                                            </div>
                                                        </draggable>
                                                    </template>
                                                    <!-- End Draggable Area -->
                                                    <div class="button-variables-container">
                                                        <draggable
                                                            class="variables-container p-3 mb-2"
                                                            v-bind:class="{ 'd-none': !isActive.button }"
                                                            draggable=".js-draggable-file-list-item"
                                                            :list="draggable_variables"
                                                            :group="{ name: 'people', pull: 'clone', put: false  }"
                                                            :sort="false"
                                                            @change="log"
                                                        >
                                                            <div
                                                                class="p-2 d-inline-block"
                                                                v-bind:class="{ 'js-draggable-file-list-item': isDraggable(template.name, draggable_variable.word), 'drag-disabled': !isDraggable(template.name, draggable_variable.word) }"
                                                                v-for="draggable_variable in draggable_variables"
                                                                :key="draggable_variable.id"
                                                            >
                                                                {{ draggable_variable.word }}
                                                            </div>
                                                            <br>
                                                        </draggable>
                                                        <b-button 
                                                            class="add-variable-button"
                                                            @click="showVariables(template)"
                                                            v-bind:class="{ active: isActive.button && isActive.id == template.customize.uuid, 'without-variables': !isActive.button }"
                                                        ></b-button>
                                                    </div>
                                                    <div class="save-changes-and-character-count-container" v-bind:class="{ 'off-set-save-changes-and-character-count': isActive.button }">
                                                        <span class="character-count">
                                                            {{ getTextLength(template.customize.custom_value_for_editing, selectedChannel) }}
                                                        </span>
                                                        <b-button
                                                            style="margin-top: 35px; width: 200px"
                                                            class="save-changes-button" 
                                                            variant="primary" 
                                                            :disabled="loading || disableSaveChangesButton(template)" 
                                                            @click="preValidateForm(templateIndex, template, channel)"
                                                        >
                                                            Save Changes and Apply
                                                        </b-button>
                                                    </div>
                                                    <span style="position: relative; top: -66px;" class="text-danger">{{ errorMessage("notification") }}</span>
                                                </template>
                                            </div>
                                        </b-card>
                                    </b-card-body>
                                </b-collapse>

                            </b-card>
                            <!-- Notification End -->
                        </div>
                    </b-tab>
                    <!-- Tab Contents End -->
                </b-tabs>
            </b-card>
            <div class="notification-success">
                <notifications width="445px" classes="notif-success" group="success" position="bottom left"/>
            </div>
        </template>
    </div>
</template>

<script>
import Switches from "vue-switches";
import draggable from "vuedraggable";
import { mapState, mapMutations } from "vuex";
import { VueEditor } from "vue2-editor";

export default {
    name: "Channel",
    data() {
        return {
            isActive: {
                id: null,
                button: false
            },
            switchTabForm: {
                templateIndex: null,
                template: null
            },
            channel: null,
            categoryUuid: null,
            categories: [],
            templates: [],
            originalCustomValue: "",
            textContentLength: 0,
            draggable_variables: [],
            draggable_custom_value: [],
            customToolbar: [],
            editorSettings: {
                modules: {
                    toolbar: false
                }
            },
            templateType: null
        };
    },
    props: [
        "loading",
        "selectedChannel",
        "selectedNotificationCategory",
        "notificationCategories",
        "notificationTemplates"
    ],
    components: {
        Switches,
        VueEditor,
        draggable
    },
    computed: {
        ...mapState("engagementNotifications", ["errors"])
    },
    methods: {
        ...mapMutations("engagementNotifications", ["setErrors"]),
        getTextLength(str, channel) {
            let text = str
                .replace(/<[^>]*>/g, "")
                .replaceAll("&lt;", "<")
                .replaceAll("&gt;", ">")
                .replaceAll("&nbsp;", " ");
            let len = text.length;
            if (channel.channel_name == "In-App Message") {
                return len + "/170";
            } else {
                return len + "/280";
            }
        },
        isDraggable(templateName, variableWord) {
            if (
                templateName == "One Time Pin" &&
                (variableWord == "<First Name>" ||
                    variableWord == "<Last Name>")
            ) {
                return false;
            } else if (
                templateName == "Welcome Message" &&
                variableWord == "<Loyalty Program Name>"
            ) {
                return false;
            } else {
                return true;
            }
        },
        disableSaveChangesButton(template) {
            let validate1 = template.customize.custom_value_for_editing.replace(
                /="/g,
                "='"
            );

            let validate2 = template.customize.original_custom_value_for_editing.replace(
                /="/g,
                "='"
            );

            validate1 = validate1.replace(/">/g, "'>");
            validate2 = validate2.replace(/">/g, "'>");

            if (validate1 !== validate2) {
                let text = template.customize.custom_value_for_editing.replace(
                    /<[^>]*>/g,
                    ""
                );
                if (text.length == 0) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return true;
            }
        },
        preValidateForm(templateIndex, template, channel) {
            this.setErrors(null);
            const errorsCollection = {};
            let customValueForEditing = template.customize.custom_value_for_editing
                .replace(/<[^>]*>/g, "")
                .replaceAll("&lt;", "<")
                .replaceAll("&gt;", ">")
                .replaceAll("&nbsp;", " ");

            if (channel.channel_name == "In-App Message") {
                if (customValueForEditing.length > 170) {
                    errorsCollection["notification"] =
                        "* The maximum length for this field is 170 characters.";
                }
            } else {
                if (customValueForEditing.length > 280) {
                    errorsCollection["notification"] =
                        "* The maximum length for this field is 280 characters.";
                }
            }
            this.setErrors(errorsCollection);
            if (Object.keys(errorsCollection).length <= 0) {
                this.setErrors(null);
                this.saveNotificationTemplate(template);
            } else {
                this.templates.types[templateIndex].customize.is_standard = 0;
                let refName = "switchTabModal" + template.uuid;
                this.$refs[refName][0].hide();
            }
        },
        errorMessage(field) {
            if (this.errors === null) {
                return "";
            } else if (Object.keys(this.errors).includes(field)) {
                return Array.isArray(this.errors[field])
                    ? this.errors[field].join(" ")
                    : this.errors[field];
            }
        },
        isVariable(value, variables) {
            for (let index = 0; index < variables.length; index++) {
                const variable = variables[index];
                if (value.includes(variable)) {
                    return true;
                }
            }
            return false;
        },
        wrapVariables: function(value, variables) {
            let formattedValue = value;
            for (let index = 0; index < variables.length; index++) {
                const variable = variables[index];
                formattedValue = formattedValue.replaceAll(
                    variable,
                    "<span style='color: rgb(81, 130, 255);'>&lt;" +
                        variable.replace("<", "").replace(">", "") +
                        "&gt;</span>"
                );

                // formattedValue = formattedValue
                //     .replaceAll(variable, "")
                //     .replace(/\s+/g, " ")
                //     .trim();
            }
            return "<p>" + formattedValue + "</p>";
        },
        log: function(evt) {
            window.console.log(evt);
        },
        getNotificationTemplates(category) {
            this.categoryUuid = category.uuid;
            if (this.selectedChannel != null && category != undefined) {
                let param = {
                    channel_uuid: this.selectedChannel.channel_uuid,
                    category_uuid: category.uuid
                };
                this.$store.dispatch(
                    "engagementNotifications/getNotificationTemplates",
                    param
                );
            }
        },
        removeVariable(index) {
            if (index !== -1) {
                this.draggable_custom_value.splice(index, 1);
            }
        },
        showVariables(template) {
            // Summary: If Button Is Active, Store Each Word In An Array To Make It Draggable. Else Put Back The Words That The Vue Editor Can Read
            this.isActive.id = template.customize.uuid;
            this.isActive.button = !this.isActive.button;
            let allowedVariables = template.standard.allowed_variables;
            let customValueForEditing = template.customize.custom_value_for_editing
                .replace(/<[^>]*>/g, "")
                .replaceAll("&lt;", "<")
                .replaceAll("&gt;", ">")
                .replaceAll("&nbsp;", " ");

            // Put Variables Into Draggable Variables Array
            for (let index = 0; index < allowedVariables.length; index++) {
                this.draggable_variables.push({
                    id: index,
                    word: allowedVariables[index]
                });
            }

            // Make Variables Into One Word
            for (let index = 0; index < allowedVariables.length; index++) {
                customValueForEditing = customValueForEditing.replaceAll(
                    allowedVariables[index],
                    allowedVariables[index].replaceAll(" ", "")
                );
            }

            if (this.isActive.button) {
                let allowedVariablesLength =
                    template.standard.allowed_variables.length;

                // Store Each Word in an Array to Make It Draggable
                if (customValueForEditing.length > 1) {
                    this.draggable_custom_value = customValueForEditing
                        .split(" ")
                        .map(currElement => {
                            return {
                                id: allowedVariablesLength++,
                                word: currElement
                            };
                        });
                }

                // Search For Variables Then Make It Readable As It Was Turned Into One Word Earlier For It To Be Stored In An Array
                for (let index = 0; index < allowedVariables.length; index++) {
                    this.draggable_custom_value = this.draggable_custom_value.map(
                        function(value) {
                            let formattedValue = {};
                            if (
                                value.word ==
                                allowedVariables[index].replaceAll(" ", "")
                            ) {
                                formattedValue = {
                                    id: value.id,
                                    word: allowedVariables[index]
                                };
                            } else if (
                                value.word.includes(
                                    allowedVariables[index].replaceAll(" ", "")
                                )
                            ) {
                                formattedValue = {
                                    id: value.id,
                                    word: value.word.replace(
                                        allowedVariables[index].replaceAll(
                                            " ",
                                            ""
                                        ),
                                        allowedVariables[index]
                                    )
                                };
                            } else {
                                formattedValue = value;
                            }
                            return formattedValue;
                        }
                    );
                }
            } else {
                customValueForEditing = "";
                for (
                    let index = 0;
                    index < this.draggable_custom_value.length;
                    index++
                ) {
                    customValueForEditing +=
                        " " + this.draggable_custom_value[index].word;
                }
                template.customize.custom_value_for_editing = this.wrapVariables(
                    customValueForEditing.trim(),
                    allowedVariables
                );
                this.draggable_custom_value = [];
                this.draggable_variables = [];
            }
        },
        countCharacters(event) {
            let editableDiv = document.getElementById(event.target.id);
            this.textContentLength = editableDiv.textContent.length;
        },
        limitCharacters(event) {
            let editableDiv = document.getElementById(event.target.id);

            // this.textContentLength = editableDiv.textContent.length;
            if (editableDiv.textContent.length >= 280) {
                event.preventDefault();
            }
        },
        switchTab(templateType, templateIndex, template) {
            this.templateType = templateType;

            let validate1 = template.customize.custom_value_for_editing.replace(
                /="/g,
                "='"
            );

            let validate2 = template.customize.original_custom_value_for_editing.replace(
                /="/g,
                "='"
            );

            validate1 = validate1.replace(/">/g, "'>");
            validate2 = validate2.replace(/">/g, "'>");

            this.switchTabForm.templateIndex = templateIndex;
            this.switchTabForm.template = template;
            if (templateType == "standard") {
                if (validate1 === validate2) {
                    this.templates.types[
                        templateIndex
                    ].customize.is_standard = 1;
                } else {
                    this.templates.types[
                        templateIndex
                    ].customize.is_standard = 1;
                    let refName = "switchTabModal";
                    this.$refs[refName].show();
                }
            } else {
                this.templates.types[templateIndex].customize.is_standard = 0;
            }
        },
        doNotSave(templateIndex, template) {
            template.customize.custom_value_for_editing =
                template.customize.original_custom_value_for_editing;
            this.templates.types[templateIndex].customize.is_standard = 1;

            if (this.isActive.button) this.showVariables(template);

            let _this = this;

            if (_this.errors == null) {
                let refName = "switchTabModal";
                _this.$refs[refName].hide();
                if (
                    _this.selectedChannel != null &&
                    _this.selectedNotificationCategory != null
                ) {
                    let param = {
                        channel_uuid: _this.selectedChannel.channel_uuid,
                        category_uuid:
                            _this.categoryUuid != null
                                ? _this.categoryUuid
                                : _this.selectedNotificationCategory.uuid
                    };
                    _this.$store.dispatch(
                        "engagementNotifications/getNotificationTemplates",
                        param
                    );
                }
            }
        },
        cancelSave(templateIndex, template) {
            let refName = "switchTabModal";
            if (
                this.templates.types[templateIndex].customize.is_standard == 0
            ) {
                this.templates.types[templateIndex].customize.is_standard = 1;
            } else {
                this.templates.types[templateIndex].customize.is_standard = 0;
            }
            this.$refs[refName].hide();
        },
        cancelToggleChannel(channel) {
            let refName = "toggleChannelModal" + channel.channel_uuid;
            this.$refs[refName].hide();
            channel.is_enabled = !channel.is_enabled;
        },
        saveToggleChannel(channel) {
            let refName = "toggleChannelModal" + channel.channel_uuid;
            let param = {
                channel_uuid: channel.channel_uuid,
                is_enabled:
                    channel.is_enabled == 1 || channel.is_enabled == true
                        ? 1
                        : 0
            };

            let titleToBeShown =
                "<i class='icon-success'></i>Save successful!</span> <a class='download-csv' href='#'>Done</a>";

            let _this = this;
            this.$store
                .dispatch("engagementNotifications/channelToggleUpdate", param)
                .then(() => {
                    if (_this.errors == null) {
                        _this.$refs[refName].hide();
                        _this.$notify({
                            group: "success",
                            title: titleToBeShown,
                            duration: 5000
                        });
                    }
                });
        },
        toggleChannel(channel) {
            if (!channel.is_enabled) {
                let refName = "toggleChannelModal" + channel.channel_uuid;
                this.$refs[refName].show();
            } else {
                let param = {
                    channel_uuid: channel.channel_uuid,
                    is_enabled:
                        channel.is_enabled == 1 || channel.is_enabled == true
                            ? 1
                            : 0
                };

                let titleToBeShown =
                    "<i class='icon-success'></i>Save successful!</span> <a class='download-csv' href='#'>Done</a>";

                let _this = this;
                this.$store
                    .dispatch(
                        "engagementNotifications/channelToggleUpdate",
                        param
                    )
                    .then(() => {
                        if (_this.errors == null) {
                            _this.$notify({
                                group: "success",
                                title: titleToBeShown,
                                duration: 5000
                            });
                        }
                    });
            }
        },
        toggleNotificationType(template) {
            let param = {
                channel_uuid: this.selectedChannel.channel_uuid,
                type_uuid: template.uuid,
                custom_value: template.customize.custom_value,
                is_enabled: template.customize.is_enabled,
                is_standard: template.customize.is_standard
            };

            let titleToBeShown =
                "<i class='icon-success'></i>Save successful!</span> <a class='download-csv' href='#'>Done</a>";

            let _this = this;
            this.$store
                .dispatch(
                    "engagementNotifications/saveNotificationTemplate",
                    param
                )
                .then(() => {
                    if (_this.errors == null) {
                        _this.$notify({
                            group: "success",
                            title: titleToBeShown,
                            duration: 5000
                        });
                    }
                });
        },
        saveNotificationTemplate(template) {
            if (this.isActive.button) this.showVariables(template);

            let param = {
                channel_uuid: this.selectedChannel.channel_uuid,
                type_uuid: template.uuid,
                custom_value: template.customize.custom_value_for_editing
                    .replace(/<[^>]*>/g, "")
                    .replaceAll("&lt;", "<")
                    .replaceAll("&gt;", ">")
                    .replaceAll("&nbsp;", " "),
                is_enabled: template.customize.is_enabled,
                is_standard: template.customize.is_standard
            };

            let titleToBeShown =
                "<i class='icon-success'></i>Save successful!</span> <a class='download-csv' href='#'>Done</a>";

            let _this = this;
            this.$store
                .dispatch(
                    "engagementNotifications/saveNotificationTemplate",
                    param
                )
                .then(() => {
                    if (_this.errors == null) {
                        _this.$notify({
                            group: "success",
                            title: titleToBeShown,
                            duration: 5000
                        });
                        let refName = "switchTabModal";
                        _this.$refs[refName].hide();
                        if (
                            _this.selectedChannel != null &&
                            _this.selectedNotificationCategory != null
                        ) {
                            let param = {
                                channel_uuid:
                                    _this.selectedChannel.channel_uuid,
                                category_uuid:
                                    _this.categoryUuid != null
                                        ? _this.categoryUuid
                                        : _this.selectedNotificationCategory
                                              .uuid
                            };
                            _this.$store.dispatch(
                                "engagementNotifications/getNotificationTemplates",
                                param
                            );
                        }
                    }
                });
        },
        resetForm(templateIndex, template) {
            this.setErrors(null);
            this.isActive.id = null;
            this.isActive.button = false;
            this.draggable_variables = [];
            this.draggable_custom_value = [];
            template.customize.custom_value_for_editing =
                template.customize.original_custom_value_for_editing;
        }
    },
    watch: {
        selectedChannel: function(selectedChannel) {
            this.channel = selectedChannel;
        },
        notificationCategories: function(notificationCategories) {
            this.categories = notificationCategories;
        },
        notificationTemplates: function(notificationTemplates) {
            this.templates = notificationTemplates;
        }
    }
};
</script>

<style lang="scss" scoped>
</style>
